'use strict';

$(window).on('load', function() {

    if ($(window).width() > 767) {

		$('.header__menu').mouseover(function() {
			$('.js-menu').removeAttr('style').css('display', 'block');	
			$('.js-menu').siblings().css({
				'color': '#fff'
			})
		})

    	$('[data-role="menu-color"]').mouseover(function() {

			$('.js-menu').removeAttr('style').css('display', 'block');
			$('.js-menu').find('.menu--color').removeClass('hidden');
			$('.js-menu').find('.menu--no-color').addClass('hidden');

			$('.js-menu').siblings().css({
				'color': '#fff'
			})

			if ($(window).width() > 767 && $(window).width() < 1025) {
				$('body').addClass('no-scroll');
		    	$('[data-role="menu-color"]').closest('.section').addClass('menu-scroll');
		    }
		})

		$('[data-role="menu-no-color"]').mouseover(function() {
			$('.js-menu').removeAttr('style').css('display', 'block');
			$('.js-menu').find('.menu--color').addClass('hidden');
			$('.js-menu').find('.menu--no-color').removeClass('hidden');

			$('.js-menu').siblings().css({
				'color': '#fff'
			});

			if ($(window).width() > 767 && $(window).width() < 1025) {
				$('body').addClass('no-scroll');
		    	$('[data-role="menu-no-color"]').closest('.section').addClass('menu-scroll');
		    }
		})

		$('.js-menu').mouseout(function() {

			$(this).css('display', 'none');
			$(this).siblings().removeAttr('style');

			if ($(window).width() > 767 && $(window).width() < 1025) {
				$('body').removeClass('no-scroll');
    			$('[data-role="menu-open"]').closest('.section').removeClass('menu-scroll');
		    }
		});
    } 
})

if ($(window).width() < 767) { 
		$('[data-role="trigger"]').each(function(index, value) {
		var $item = $(this).parent();

		if($item.find('.menu-inner__list').length !== 0 || $item.find('.nav-inner__list').length !== 0) {
			$(this).addClass('menu__arrow');
		}
	});


	$('[data-role="trigger"]').on('click', function(e) {
		e.preventDefault();
		var $trigger = $(e.currentTarget);
		var $item = $trigger.parent();

		if ($item.hasClass('menu__item')) {
			$item.toggleClass('is-open');
			$item.siblings().removeClass('is-open').find('.menu-inner__list').slideUp();
			$trigger.next().stop().slideToggle(300);
		}
	});
}
